import { resourceState, resourceMutations } from '@/store/utils/resource';
import { FORMS } from '@/store/entities/schema_types';
import { accountFormClient as service } from '@/api/clients';

export default {
  namespaced: true,
  state: resourceState(),
  mutations: resourceMutations,
  actions: {
    async fetchAccountFormList(ctx, { accountId, params = {} }) {
      try {
        const response = await service.list(accountId, { params });
        const { data, meta, links } = response.data;
        const ids = await ctx.dispatch('persist', { type: FORMS, data });
        ctx.commit('setIds', ids);
        ctx.commit('setMeta', meta);
        ctx.commit('setLinks', links);
        return Promise.resolve({
          ids,
          meta,
          links,
        });
      } catch (error) {
        const { response } = error;
        return Promise.reject(response);
      }
    },

    async storeAccountForm(ctx, { accountId, formData = {} }) {
      try {
        const response = await service.store(accountId, formData);
        const { data } = response.data;
        const formUuid = await ctx.dispatch('persist', { type: FORMS, data });
        ctx.commit('setCurrent', formUuid);
        return Promise.resolve({ formUuid });
      } catch (error) {
        const { response } = error;
        return Promise.reject(response);
      }
    },
    persist(ctx, { type, data }) {
      return ctx.dispatch(
        'entities/persistEntities',
        {
          type,
          data,
        },
        { root: true }
      );
    },
  },
  getters: {
    forms({ ids }, getters, { entities }) {
      return ids.map((id) => entities.forms.byId[id]);
    },
    form({ current }, getters, { entities }) {
      if (!current) return null;
      return entities.forms.byId[current] || null;
    },
  },
};
